import { useMsal } from '@azure/msal-react'
import { t } from 'i18next'
import { PrimitiveAtom, useAtom } from 'jotai'
import { useEffect } from 'react'
import { Trans } from 'react-i18next'

import { Link } from '@/components/ui/link'
import { addNotification } from '@/store/gigiChat/Notifications'
import { quotasAtom, showQuotasDrawerAtom, toggleQuotasDrawer } from '@/store/gigiChat/Quotas'
import { helpCenterTopicsAtom, sendHelpData } from '@/store/helpCenter'
import { IQuotas } from '@/types/gigiChat/Quotas'
import { ITopic } from '@/types/helpCenter'

import QuotasDrawer from './QuotasDrawer'

const Container = () => {
    const { accounts } = useMsal()
    const [helpCenterTopics] = useAtom<ITopic[]>(helpCenterTopicsAtom)
    const [quotas] = useAtom<PrimitiveAtom<IQuotas | null>>(quotasAtom)
    const [showQuotasDrawer] = useAtom<boolean>(showQuotasDrawerAtom)
    const onClose = () => {
        toggleQuotasDrawer()
    }

    useEffect(() => {
        const wasQuotaDisplayed = sessionStorage.getItem('quotasShowed')

        if (quotas && !quotas.individual.creditsRemaining && !wasQuotaDisplayed) {
            addNotification(
                'error',
                <Trans
                    i18nKey={'global.quotas.toast.error'}
                    components={[<Link onClick={toggleQuotasDrawer} textDecoration="underline" />]}
                />,
            )
            sessionStorage.setItem('quotasShowed', 'true')
        }
    }, [quotas])

    const onSendRequest = (message: string) => {
        const topic = helpCenterTopics.find((item) => item.type === 'RAISE_QUOTA') as ITopic
        const userName: string = (accounts[0].name as string) || ''
        const title = t('global.quotas.request.title', { topic: topic?.name, name: userName })

        void sendHelpData({ title, message, id: topic.id }).then((res) => {
            if (res) {
                addNotification('success', t('global.helpCenter.toast.success'))
                toggleQuotasDrawer()
            }
        })
    }

    if (!quotas) {
        return null
    }

    // TODO: refactor this. It duplicates the logic from Progress
    let quotaPercentage: number

    if (quotas.individual.creditsQuota === 0) {
        quotaPercentage = 0
    } else {
        quotaPercentage = Number(((quotas.individual.creditsRemaining / quotas.individual.creditsQuota) * 100).toFixed(0))
    }

    return (
        <QuotasDrawer
            isOpen={showQuotasDrawer}
            onClose={onClose}
            quotas={quotas}
            percentage={quotaPercentage}
            onMoreQuota={onSendRequest}
        />
    )
}

export default Container
